import axios from "axios";
import { Message } from "element-ui";
import Cookies from 'js-cookie';
//这里面加入后端的地址
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 5000,
});

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(
  (config) => {
    let token = Cookies.get('userToken'); // 获取名为key的cookie的值
    // console.log(token,'13');
    config.headers["Content-Type"] = "application/json;charset=utf-8";
    if (token && token !== 'undefined') {
      config.headers['Authorization']='Bearer '+ token;
    }
    // config.headers['token'] = user.token;  // 设置请求头
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      if(res.code===401){
          console.log('401。。。。。。。');
        // location.href = process.env.VUE_APP_BASE_URL_LOGIN+'/login'
      }
      const errCodeMap = {
        443:()=>{
         window.location.href = process.env.VUE_APP_BASE_URL_LOGIN
        },
        444:()=>{
         window.location.href = process.env.VUE_APP_BASE_URL_LOGIN 
        },
        600:()=>{
          Message.success(res.msg||res.message||'Error')
        },
        500:()=>{
          Message.error(res.msg||res.message||'Error')
        }
      }
      errCodeMap[res.code]&& errCodeMap[res.code]()
      
      // alert(res.message || "Error");
      // return Promise.reject(new Error(res.message || "Error"));
    } else {
      // if(res.rows){
      //   res.rows.forEach((v,i) => {
      //     v.number = i + 1
      //   });
      // }
      // if(Array.isArray(res.data)){
      //   res.data.forEach((v,i) => {
      //     v.number = i + 1
      //   });
      // }
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default request;
